import { jsx as _jsx } from "react/jsx-runtime";
import { clientSide } from "../ssr";
import React, { useEffect, useState } from "react";
import { propagateAttribution } from "./propagateAttribution";
export const SESSION_ATTRIBUTION_KEY = 'castiron-session-attribution';
export const determineAttribution = () => clientSide(() => {
    try {
        const attribJson = sessionStorage.getItem(SESSION_ATTRIBUTION_KEY);
        return attribJson
            ? JSON.parse(attribJson)
            : {
                source: "unknown",
                referringSourceUrl: window === null || window === void 0 ? void 0 : window.document.referrer,
            };
    }
    catch (err) {
        console.error('Error getting attribution', err);
        return {
            source: "unknown",
            referringSourceUrl: window === null || window === void 0 ? void 0 : window.document.referrer,
        };
    }
});
export const AttributionContext = React.createContext(undefined);
export const AttributionConfig = (props) => {
    const [attribution, setAttribution] = useState(determineAttribution());
    console.debug('Attribution', attribution);
    useEffect(() => {
        if (!attribution) {
            propagateAttribution().then(a => setAttribution(a));
        }
    }, [attribution]);
    return _jsx(AttributionContext.Provider, Object.assign({ value: attribution }, { children: props.children }), void 0);
};
//# sourceMappingURL=index.js.map